import React from 'react';
import { Filter, TrendingDown } from 'lucide-react';

function GatingVisualization({ gating }) {
  if (gating.skipped) {
    return (
      <div className="bg-gray-800/50 backdrop-blur rounded-lg p-6">
        <h3 className="text-xl font-bold mb-2 flex items-center gap-2">
          <Filter className="w-5 h-5" />
          USAD Gating
        </h3>
        <p className="text-gray-400">
          Skipped (insufficient jumps for calibration)
        </p>
      </div>
    );
  }

  const passRate = (gating.passed / gating.total) * 100;
  const computeSaved = ((gating.filtered / gating.total) * 100).toFixed(0);

  return (
    <div className="bg-gray-800/50 backdrop-blur rounded-lg p-6">
      <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
        <Filter className="w-5 h-5 text-purple-400" />
        USAD Conformal Gating
      </h3>
      <div className="grid grid-cols-4 gap-4 mb-6">
        <div className="bg-gray-700/50 rounded-lg p-4">
          <p className="text-sm text-gray-400">Total Jumps</p>
          <p className="text-3xl font-bold">{gating.total}</p>
        </div>
        <div className="bg-gray-700/50 rounded-lg p-4">
          <p className="text-sm text-gray-400">Calibration</p>
          <p className="text-3xl font-bold text-blue-400">{gating.calibration}</p>
        </div>
        <div className="bg-gray-700/50 rounded-lg p-4">
          <p className="text-sm text-gray-400">Passed Gate</p>
          <p className="text-3xl font-bold text-green-400">{gating.passed}</p>
        </div>
        <div className="bg-gray-700/50 rounded-lg p-4">
          <p className="text-sm text-gray-400">Filtered</p>
          <p className="text-3xl font-bold text-red-400">{gating.filtered}</p>
        </div>
      </div>

      {/* Visual bar */}
      <div className="h-8 rounded-lg overflow-hidden flex mb-4">
        <div
          className="bg-blue-500 flex items-center justify-center text-xs font-semibold"
          style={{ width: `${(gating.calibration / gating.total) * 100}%` }}
        >
          Cal
        </div>
        <div
          className="bg-green-500 flex items-center justify-center text-xs font-semibold"
          style={{ width: `${(gating.passed / gating.total) * 100}%` }}
        >
          Pass
        </div>
        <div
          className="bg-red-500 flex items-center justify-center text-xs font-semibold"
          style={{ width: `${(gating.filtered / gating.total) * 100}%` }}
        >
          Filter
        </div>
      </div>

      <div className="flex items-center gap-2 text-green-400">
        <TrendingDown className="w-5 h-5" />
        <span className="font-semibold">
          {computeSaved}% compute saved by gating
        </span>
      </div>
    </div>
  );
}

export default GatingVisualization;

